<template>
  <AuthGuard>
    <v-container class="container">
      <v-card class="mt-16 w-50 ml-auto mr-auto">
        <v-card-title
          >Connect
          <v-chip color="blue">{{ getFeedNameFromFeedType(state.feedType) }}</v-chip>
          Account</v-card-title
        >
        <v-card-text>
          <v-row gutter="20">
            <v-col cols="12"
              ><v-text-field v-model="state.name" label="Account Name" required></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-btn
                @click="handleClickSubmit"
                :loading="state.isLoading"
                variant="elevated"
                color="primary"
                >Submit</v-btn
              >
            </v-col>
            <v-col cols="6" align="right">
              <v-btn :to="URLs.PAGE_CUSTOMER_SOURCES(state.customerId)">Go Profile</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </AuthGuard>
</template>

<script setup lang="ts">
import AuthGuard from "@/components/Auth/AuthGuard.vue";
import { URLs, Env } from "@/constants";
import { connectGoogleAccountSchema } from "@/schemas";
import { useAccountStore } from "@/stores/account";
import { useAuthStore } from "@/stores/auth";
import { IApp } from "@/types";
import { getFeedNameFromFeedType, getAppEnv, validate, makeAlert } from "@/utils";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const user = computed(() => authStore.user);

const accountStore = useAccountStore();
const router = useRouter();

const params = new URLSearchParams(location.search);
const data: { type: IApp.IFeedTypes; customerId: string } = JSON.parse(params.get("state")!);

const state = ref<{
  feedType: IApp.IFeedTypes;
  code: string;
  name: string;
  isLoading: boolean;
  customerId: string;
}>({
  feedType: data.type,
  code: params.get("code")!,
  name: "",
  isLoading: false,
  customerId: data.customerId
});

const handleClickSubmit = async () => {
  const validated = validate(connectGoogleAccountSchema, {
    userId: user.value?.id!,
    type: state.value.feedType,
    name: state.value.name,
    code: state.value.code,
    redirectUrl: Env.REDIRECT_URL,
    env: getAppEnv(),
    customerId: state.value.customerId
  });
  state.value.isLoading = true;
  if (validated.status) {
    const response = await accountStore.connectGoogleAccount(validated.data);
    if (response.status) {
      makeAlert("Account connected successfully", "success");
      makeAlert("Redirecting to source management page...", "info");
      setTimeout(() => {
        router.push(URLs.PAGE_CUSTOMER_SOURCES(state.value.customerId));
      }, 3000);
    } else {
      if (response.message === "invalid_grant") {
        makeAlert("Invalid code. Please try again from the beginning.", "error");
      } else {
        makeAlert(response.message, "error");
      }
    }
  } else {
    makeAlert(validated.message, "error");
  }
  state.value.isLoading = false;
};
</script>
